/**
****************************************************************************************
Project: Readabl
File: PdfRenderLoader.js
Description: This component will add loader to PDFViewer component.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React from "react";

const PdfRenderLoader = ({percentage}) => { 
    return (
        percentage > 0 && percentage < 100 ? <div className="pdf-viewer-loader-container">
            <div className="pdf-viewer-loader">
                <div style={{width: `${percentage+ "%"}`}} className="pdf-viewer-loader-percentage-bar">
                </div>
            </div>
        </div> : null
    )
}

export default PdfRenderLoader;